/* Pink Fantasy sparkles — cursor trail (mouse/trackpad only) + click/tap burst.
   Pure DOM + CSS transforms, capped particle count, off for reduced-motion users. */
(function () {
  if (window.__pfSparkle) return;
  window.__pfSparkle = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cfg = document.getElementById('pf-sparkle-config');
  var opts = {
    trail: !cfg || cfg.dataset.trail !== 'false',
    burst: !cfg || cfg.dataset.burst !== 'false',
    colors: ((cfg && cfg.dataset.colors) || '#FF3E9A,#FF8CC6,#FFFFFF,#FFD1E8,#F5C26B').split(',')
  };
  var MAX = 70;

  var css =
    '.pf-sparkle-layer{position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;contain:strict}' +
    '.pf-sparkle{position:absolute;width:var(--sz);height:var(--sz);background:var(--c);will-change:transform,opacity;' +
    'clip-path:polygon(50% 0%,62% 38%,100% 50%,62% 62%,50% 100%,38% 62%,0% 50%,38% 38%);' +
    'animation:pfSpark var(--t) cubic-bezier(.2,.6,.3,1) forwards}' +
    '.pf-sparkle--dot{clip-path:none;border-radius:50%;box-shadow:0 0 8px 2px var(--c)}' +
    '@keyframes pfSpark{0%{transform:translate(-50%,-50%) scale(var(--s)) rotate(0deg);opacity:1}' +
    '100%{transform:translate(calc(-50% + var(--dx)),calc(-50% + var(--dy))) scale(0) rotate(var(--r));opacity:0}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var layer;
  function ensureLayer() {
    if (layer && layer.isConnected) return layer;
    layer = document.createElement('div');
    layer.className = 'pf-sparkle-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
    return layer;
  }

  function rand(a, b) { return a + Math.random() * (b - a); }

  function spawn(x, y, dist, size, dur, dot) {
    var l = ensureLayer();
    if (l.childElementCount >= MAX) return;
    var s = document.createElement('span');
    s.className = dot ? 'pf-sparkle pf-sparkle--dot' : 'pf-sparkle';
    var ang = rand(0, Math.PI * 2);
    var d = rand(dist * 0.4, dist);
    s.style.left = x + 'px';
    s.style.top = y + 'px';
    s.style.setProperty('--dx', Math.cos(ang) * d + 'px');
    s.style.setProperty('--dy', Math.sin(ang) * d + (dot ? 0 : 10) + 'px');
    s.style.setProperty('--sz', size + 'px');
    s.style.setProperty('--s', rand(0.7, 1.2).toFixed(2));
    s.style.setProperty('--r', rand(-180, 180).toFixed(0) + 'deg');
    s.style.setProperty('--t', dur + 'ms');
    s.style.setProperty('--c', opts.colors[(Math.random() * opts.colors.length) | 0]);
    s.addEventListener('animationend', function () { s.remove(); }, { once: true });
    l.appendChild(s);
  }

  // Cursor trail: only on devices with a real mouse/trackpad
  if (opts.trail && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var last = 0, lx = 0, ly = 0;
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var now = performance.now();
      var moved = Math.abs(e.clientX - lx) + Math.abs(e.clientY - ly);
      if (now - last < 35 || moved < 6) return;
      last = now; lx = e.clientX; ly = e.clientY;
      spawn(e.clientX + rand(-4, 4), e.clientY + rand(-4, 4), 26, rand(7, 13), rand(600, 900), Math.random() < 0.35);
    }, { passive: true });
  }

  // Click / tap burst: everywhere
  if (opts.burst) {
    window.addEventListener('pointerdown', function (e) {
      var n = 12;
      for (var i = 0; i < n; i++) {
        spawn(e.clientX, e.clientY, 70, rand(9, 17), rand(650, 1000), i % 3 === 0);
      }
    }, { passive: true });
  }
})();
